import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=3e228a96&scoped=true&"
import script from "./Homepage.vue?vue&type=script&lang=js&"
export * from "./Homepage.vue?vue&type=script&lang=js&"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=3e228a96&prod&lang=scss&scoped=true&"
import style1 from "./Homepage.vue?vue&type=style&index=1&id=3e228a96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e228a96",
  null
  
)

export default component.exports